<template>
  <div class="card-filter">
    <el-row
      type="flex"
      align="start"
      justify="space-between"
      class="flex-wrap mb-l gap-12"
    >
      <el-row
        type="flex"
        align="middle"
      >
        <el-input
          v-model="textSearch"
          class="text-search mr-m"
          placeholder="Nhập thông tin để tìm kiếm"
          clearable
        />
        <ItemSelect
          v-for="field in fastFilterFields"
          :key="field.key"
          class="mr-m"
          :form="fastFilterForm"
          :field="field"
          :config="config"
        />
        <el-button
          size="large"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchNormal"
        >
          Tìm kiếm
        </el-button>
      </el-row>
      <div>
        <el-button
          size="medium"
          type="primary"
          icon="el-icon-caret-bottom"
          @click="() => $emit('advance-search')"
        >
          Tìm kiếm nâng cao
        </el-button>
      </div>
    </el-row>
  </div>
</template>

<script>
import ItemSelect from "@/components/items/Select.vue"
import { arrayToObject } from "@/utils/common";
export default {
  name: "CardFilter",
  components: {
    ItemSelect
  },
  props: {
    config: Object
  },
  data() {
    return {
      textSearch: "",
      fastFilterForm: {},
    };
  },
  computed: {
    fastFilterFields() {
      return this.config.extra.fields.filter((f) => f.show.fast_filter)
    }
  },
  mounted() {
    this.fastFilterForm = arrayToObject(this.fastFilterFields)
  },
  methods: {
    searchNormal() {
      this.$emit("search", {
        searchText: this.textSearch,
        fastFilter: this.fastFilterForm
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-filter {
  .text-search {
    min-width: 200px;
  }
}
</style>
